module.exports = __webpack_public_path__ + "html/datasheet-form.template.html";